export function agencyTapEngineAddressIncomplete(user) {
  const address = user?.address
  if (!address) return true
  return (
    address.address === '' ||
    address.city === '' ||
    address.state === '' ||
    address.zip === '' ||
    address.country === ''
  )
}

export function agencyRequiresTapEngineAddress(user) {
  return Boolean(
    user &&
      user.role === 'Agency' &&
      user.has_te &&
      agencyTapEngineAddressIncomplete(user)
  )
}
